<template>
  <div>
    <br />
    <br />
    <div class="row align-items-end">
      <!-- <div class="col-xl-3 col-12">
        <label for="">Catégorie</label>
        <vue-select :options="sections" v-model="section_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />
      </div> -->

      <div class="col-xl-3 col-12">
        <label for="">Produit</label>

        <vue-select :options="filteredItems" v-model="orderItem.item_reference" labelColumn="fullName"
          valueColumn="reference" />
      </div>

      <div class="col-xl col-12">
        <label for="">Prix U </label>
        <input  type="text" v-model="orderItem.priceTTC" class="form-control" />
      </div>

      <div class="col-xl col-12">
        <label for="">Quantité (kg) </label>
        <input type="text" v-model="orderItem.quantity" class="form-control" />
      </div>


      <div class="col-xl col-12">
        <label for="">NB </label>
        <input type="text" v-model="orderItem.remark" class="form-control" />
      </div>

      <div class="col-xl-auto col">
        <label for=""></label>
        <button class="btn btn-success" @click="save(orderItem)">
          <i class="bi bi-plus-circle"></i> Insérer
        </button>
      </div>

      <div class="col-xl-auto col-auto">
        <button class="btn btn-secondary d-flex align-items-center" @click="refresh()">
          <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
          <span> Actualiser </span>
        </button>
      </div>
    </div>
    <br />

    <vue-data-table :headers="headers" :data="orderItems" :items-per-page="10" :buttons="buttons"
      :summable-columns="summableColumns">

      <template #cell-priceTTC="{ row }">
        <span class="px-2 py-1 rounded "
          :class="row.priceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.priceTTC }}
        </span>
      </template>
 

      <template #cell-totalPriceTTC="{ row }">
        <span class="px-2 py-1 rounded " 
          :class="row.totalPriceTTC > 0 ? 'bg-light-primary text-primary' : 'bg-light-danger text-danger'">
          {{ row.totalPriceTTC }}
        </span>
      </template>

      <template #footer-totalPriceTTC="{ column, sum }">
        <span class="fw-bold text-success">
          {{ sum }}
        </span>
      </template>

    </vue-data-table>
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="validated()" v-if="orderItems">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      orderItem: {},
      section_reference: "",
      selectedItem: {},
      accept: false,
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'priceTTC', label: 'Prix', class: 'fw-bold' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'totalPriceTTC', label: 'Total', class: 'fw-bold' },
        { field: 'remark', label: 'NB', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      buttons: [
        
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      summableColumns: [
        { field: 'totalPriceTTC', class: 'tfw-bold' },
        { field: 'quantity', class: 'fw-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("order", {
      orderItems: "getItems",
    }),
    filteredItems() {
      if (!this.section_reference) return this.items;
      return this.items.filter(item => item.section_reference === this.section_reference);
    },
  }, 
  methods: {
    async save(data) {
      await this.$store.dispatch("order/storeItem", data);
      this.orderItem = {  quantity: "", priceTTC: "", pcs: "" };
    },
    async refresh() {
      await this.$store.dispatch("section/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("order/getAllItems");
    },
    async validated() {
      this.$router.push({ name: "orders-create" });
    },
  
    async deleteItem(item) {
      await this.$store.dispatch("order/destroyItem", item.id);
    },
  },
  beforeMount() {
    this.refresh();
  },
  watch: {
    'orderItem.item_reference': function (newValue) {
      if (newValue) {
        this.selectedItem = this.filteredItems.find(item => item.reference === newValue) || {};
        this.orderItem.priceTTC = parseFloat(this.selectedItem.priceTTC) || "";
      }
    },
    'orderItem.pcs': function (newValue) {
      if (newValue && this.selectedItem.pcs) {
        this.orderItem.quantity = parseFloat(newValue / this.selectedItem.pcs).toFixed();
      }
    },
    'orderItem.quantity': function (newValue) {
      if (newValue && this.selectedItem.pcs) {
        this.orderItem.pcs = parseFloat(newValue * this.selectedItem.pcs).toFixed();
      }
    }
  }
};
</script>

<style scoped></style>